
import { MapLocation } from '@/types/location';
import { aboveAndBeyondGyms } from './aboveAndBeyondGyms';
import { arenaFitnessGyms } from './arenaFitnessGyms';
import { asagGyms } from './asagGyms';
import { auraCentersGyms } from './auraCentersGyms';
import { cosmicGyms } from './cosmicGyms';
import { denGyms } from './denGyms';
import { downTownGyms } from './downTownGyms';
import { eliteArenaGyms } from './eliteArenaGyms';
import { fat2FitGyms } from './fat2FitGyms';
import { fitFactoryGyms } from './fitFactoryGyms';
import { fitYouGyms } from './fitYouGyms';
import { fitoniaGyms } from './fitoniaGyms';
import { futureHeroesGyms } from './futureHeroesGyms';
import { invictusFighterGyms } from './invictusFighterGyms';
import { jfRevolutionGyms } from './jfRevolutionGyms';
import { karateHouseGyms } from './karateHouseGyms';
import { legendLadiesGyms } from './legendLadiesGyms';
import { locaStudiosGyms } from './locaStudiosGyms';
import { monsterCageGyms } from './monsterCageGyms';
import { n2FitnessGyms } from './n2FitnessGyms';
import { nineRoundFemaleGyms } from './nineRoundFemaleGyms';
import { nineRoundMaleGyms } from './nineRoundMaleGyms';
import { powerSquareGyms } from './powerSquareGyms';
import { powerStageGyms } from './powerStageGyms';
import { proMakerGyms } from './proMakerGyms';
import { realLifeGyms } from './realLifeGyms';
import { rhythmCalisthenicsGyms } from './rhythmCalisthenicsGyms';
import { strikerGyms } from './strikerGyms';
import { threeDaysGyms } from './threeDaysGyms';
import { trainWayGyms } from './trainWayGyms';
import { ufcGyms } from './ufcGyms';
import { ultimatePowerGyms } from './ultimatePowerGyms';
import { unityGyms } from './unityGyms';
import { vidafitGyms } from './vidafitGyms';
import { vitalityClubGyms } from './vitalityClubGyms';
import { wawanGyms } from './wawanGyms';
import { worldOfCreativityGyms } from './worldOfCreativityGyms';
import { xfitGyms } from './xfitGyms';

// Combine all gym locations
export const alanGymLocations: MapLocation[] = [
  ...wawanGyms,          // Wawan Gyms
  ...xfitGyms,           // Xfit Gyms
  ...cosmicGyms,         // Cosmic Gyms
  ...ultimatePowerGyms,  // Ultimate Power Gyms
  ...vidafitGyms,        // Vidafit Gyms
  ...auraCentersGyms,    // Aura Centers Gyms
  ...nineRoundMaleGyms,  // 9Round Male Gyms
  ...nineRoundFemaleGyms, // 9Round Female Gyms
  ...realLifeGyms,       // Real Life Gyms
  ...locaStudiosGyms,    // LoCa Studios Gyms
  ...fitYouGyms,         // Fit You Gyms
  ...proMakerGyms,       // ProMaker Gyms
  ...karateHouseGyms,    // Karate House Gyms
  ...legendLadiesGyms,   // Legend Ladies Gyms
  ...threeDaysGyms,      // 3 Days Gyms
  ...denGyms,            // DEN Gyms
  ...asagGyms,           // ASAG Gyms
  ...downTownGyms,       // DownTown Gyms
  ...fat2FitGyms,        // Fat2Fit Gyms
  ...strikerGyms,        // Striker Gyms
  ...fitoniaGyms,        // Fitonia Gyms
  ...aboveAndBeyondGyms, // Above & Beyond Gyms
  ...fitFactoryGyms,     // Fit Factory Gyms
  ...ufcGyms,            // UFC Gyms
  ...unityGyms,          // Unity Gyms
  ...trainWayGyms,       // Train Way Gyms
  ...powerStageGyms,     // Power Stage Gyms
  ...rhythmCalisthenicsGyms, // Rhythm Calisthenics Gyms
  ...vitalityClubGyms,   // Vitality Club Gyms
  ...arenaFitnessGyms,   // Arena Fitness Gyms
  ...jfRevolutionGyms,   // J. F. Revolution Gyms
  ...worldOfCreativityGyms, // The World of Creativity Gyms
  ...eliteArenaGyms,     // Elite Arena Gyms
  ...invictusFighterGyms, // INVICTUS FIGHTER Gyms
  ...n2FitnessGyms,      // N2 Fitness Gyms
  ...monsterCageGyms,    // Monster Cage Gyms
  ...futureHeroesGyms,   // Future Heroes Gyms
  ...powerSquareGyms     // Power Square Gyms
];
